import { Box, Card, CardContent, Tab, Tabs, Typography } from "@mui/material";
import React, { useState } from "react";
import AdminDashboardLayout from "../../../layouts/admin_dashboard_layout/admin_dashboard_layout";
import UploadAboutLeaderTab from "./upload_about_leader_tab";
import ManageAboutLeadersTab from "./manage_about_leaders_tab";
import HomeBannerSettingsTab from "./home_banner_settings_tab";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`about-tabpanel-${index}`}
      aria-labelledby={`about-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export default function AboutAdminPage() {
  const [currentTab, setCurrentTab] = useState(0);

  return (
    <AdminDashboardLayout>
      <Box flex={1} mt={2} mx={2}>
        <Card sx={{ borderRadius: 1, m: 3 }} elevation={1}>
          <CardContent>
            <Typography variant="h5" fontWeight="600" mb={2}>
              About Us Management
            </Typography>

            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={currentTab}
                onChange={(_, newValue) => setCurrentTab(newValue)}
                aria-label="about us management tabs"
                variant="scrollable"
                scrollButtons="auto"
              >
                <Tab label="Add Leader" id="about-tab-0" />
                <Tab label="Manage Leaders" id="about-tab-1" />
                <Tab label="Home Banners" id="about-tab-2" />
              </Tabs>
            </Box>

            <TabPanel value={currentTab} index={0}>
              <UploadAboutLeaderTab onSuccess={() => setCurrentTab(1)} />
            </TabPanel>

            <TabPanel value={currentTab} index={1}>
              <ManageAboutLeadersTab />
            </TabPanel>

            <TabPanel value={currentTab} index={2}>
              <HomeBannerSettingsTab />
            </TabPanel>
          </CardContent>
        </Card>
      </Box>
    </AdminDashboardLayout>
  );
}
